<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import NavBar from '@/components/blog/header/NavBar.vue'

import SubscriptionBanner from '@/components/blog/SubscriptionBanner.vue'
import Topics from '@/components/blog/MoreTopics.vue'

import BlogsService from '@/services/content-app/blog.service'
import type { ICategory } from '@/components/content-app/interface/blog/IBlogCategory'

const route = useRoute()
const categories = ref<ICategory[]>([])
const _BlogsService = new BlogsService()

onMounted(async () => {
  categories.value = await _BlogsService.getAllCategories()
})
</script>

<template>
  <div>
    <div class="flex justify-center bg-[#F7F7F7] py-4 xl:py-5 dark:bg-[#25272C]">
      <NavBar :key="route.fullPath" :categories="categories" />
    </div>
    <router-view :key="route.fullPath"></router-view>
    <Topics :categories="categories" />
    <SubscriptionBanner />
  </div>
</template>
